import { Avatar, SxProps, Typography } from "@mui/material";

type Props = {
  isRTK: boolean;
  sx?: SxProps;
};

export const RTKIcon = (props: Props) => {
  return (
    <Avatar
      sx={{
        backgroundColor: props.isRTK ? "#2E7D3290" : "#4C6CB3",
        color: "white",
        borderRadius: "0px",
        height: "24px",
        width: "44px",
        fontSize: "small",
        margin: "0 0 0 auto",
      }}
      variant="square"
    >
      <Typography
        gutterBottom
        variant="body2"
        component="div"
        sx={{
          marginTop: "6px",
          marginBottom: "6px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          height: "20px",
        }}
      >
        {props.isRTK ? "RTK" : "GPS"}
      </Typography>
    </Avatar>
  );
};
